import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import { useLanguage } from '../../context/LanguageContext';
import emailjs from '@emailjs/browser';

const ContactForm = () => {
    const { t } = useLanguage();

    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
    });
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));

    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = e => {
        e.preventDefault();
        if (validator.allValid()) {
            const serviceId = 'service_y12ki5o';
            const templateId = 'template_4gpsr4m';
            const publicKey = 'j06CTZjvPb6dp87a-';

            const templateParams = {
                name: forms.name,
                email: forms.email,
                phone: forms.phone,
                subject: forms.subject,
                message: forms.message
            };

            emailjs.send(serviceId, templateId, templateParams, publicKey)
                .then((response) => {
                    alert(t('contact.success'));
                    setForms({ name: '', email: '', subject: '', phone: '', message: '' });
                    validator.hideMessages();
                }, (err) => {
                    alert(t('contact.error'));
                });
        } else {
            validator.showMessages();
        }
    };

    return (
        <form onSubmit={(e) => submitHandler(e)} className="contact-validation-active">
            <div className="row">
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.name}
                            type="text"
                            name="name"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder={t('contact.namePlaceholder')} />
                        {validator.message('name', forms.name, 'required', {
                            messages: { required: t('contact.nameReq') }
                        })}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder={t('contact.emailPlaceholder')} />
                        {validator.message('email', forms.email, 'required|email', {
                            messages: { required: t('contact.emailReq'), email: t('contact.emailInvalid') }
                        })}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.phone}
                            type="phone"
                            name="phone"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder={t('contact.phonePlaceholder')} />
                        {validator.message('phone', forms.phone, 'required', {
                            messages: { required: t('contact.phoneReq') }
                        })}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.subject}
                            type="text"
                            name="subject"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder={t('contact.subjectPlaceholder')} />
                        {validator.message('subject', forms.subject, 'required', {
                            messages: { required: t('contact.subjectReq') }
                        })}
                    </div>
                </div>
                <div className="col col-lg-12 col-12">
                    <textarea
                        onBlur={(e) => changeHandler(e)}
                        onChange={(e) => changeHandler(e)}
                        value={forms.message}
                        type="text"
                        name="message"
                        placeholder={t('contact.messagePlaceholder')}>
                    </textarea>
                    {validator.message('message', forms.message, 'required', {
                        messages: { required: t('contact.messageReq') }
                    })}
                </div>
            </div>
            <div className="submit-area">
                <button type="submit" className="theme-btn">{t('contact.submitBtn')}</button>
            </div>
        </form>
    )
}

export default ContactForm;
